import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { JobService } from './services/job.service';
import { LoginService } from './services/login.service';
import { PostalService } from './services/postal.service';
import { RegisterService } from './services/register.service';

declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: 'create-job',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  step = 1;
  amountOfSteps = 4;
  _dateExecution!: Date;
  get dateExecution() { return this._dateExecution; }
  set dateExecution(val) { this._dateExecution = val; this.saveLocalStorage(); }

  _weekRange = "";
  get weekRange() { return this._weekRange; }
  set weekRange(val) { this._weekRange = val; this.saveLocalStorage(); }

  _title = "";
  get title() { return this._title; }
  set title(val) { this._title = val; this.saveLocalStorage(); }

  _description = "";
  get description() { return this._description; }
  set description(val) { this._description = val; this.saveLocalStorage(); }

  _postal = "";
  get postal() { return this._postal; }
  set postal(val) { this._postal = val; this.saveLocalStorage(); }

  _houseNumber = "";
  get houseNumber() { return this._houseNumber; }
  set houseNumber(val) { this._houseNumber = val; this.saveLocalStorage(); }

  _houseNumberAddition = "";
  get houseNumberAddition() { return this._houseNumberAddition; }
  set houseNumberAddition(val) { this._houseNumberAddition = val; this.saveLocalStorage(); }

  _street = "";
  get street() { return this._street; }
  set street(val) { this._street = val; this.saveLocalStorage(); }

  _city = "";
  get city() { return this._city; }
  set city(val) { this._city = val; this.saveLocalStorage(); }

  addressValid = false;

  _detailsLength!: number;
  get detailsLength() { return this._detailsLength; }
  set detailsLength(val) { this._detailsLength = val; this.saveLocalStorage(); }

  _detailsWidth!: number;
  get detailsWidth() { return this._detailsWidth; }
  set detailsWidth(val) { this._detailsWidth = val; this.saveLocalStorage(); }

  _detailsHeight!: number;
  get detailsHeight() { return this._detailsHeight; }
  set detailsHeight(val) { this._detailsHeight = val; this.saveLocalStorage(); }

  _radioDoorType: any;
  get radioDoorType() { return this._radioDoorType; }
  set radioDoorType(val) { this._radioDoorType = val; this.saveLocalStorage(); }

  _cbDrawers = false;
  get cbDrawers() { return this._cbDrawers; }
  set cbDrawers(val) { this._cbDrawers = val; this.saveLocalStorage(); }

  _cbLights = false;
  get cbLights() { return this._cbLights; }
  set cbLights(val) { this._cbLights = val; this.saveLocalStorage(); }

  _cbExtra = false;
  get cbExtra() { return this._cbExtra; }
  set cbExtra(val) { this._cbExtra = val; this.saveLocalStorage(); }

  _txtExtra = "";
  get txtExtra() { return this._txtExtra; }
  set txtExtra(val) { this._txtExtra = val; this.saveLocalStorage(); }

  file1!: File;
  file1Preview!: string;

  _fileUploaded = false;
  get fileUploaded() { return this._fileUploaded; }
  set fileUploaded(val) { this._fileUploaded = val; this.saveLocalStorage(); }

  file2!: File;
  file2Preview!: string;
  manualUrl = "";
  guideProvided = false;

  loginUserName = "";
  loginPassword = "";
  registerFirstName = "";
  registerLastName = "";
  registerEmail = "";
  registerPassword = "";
  registerPasswordConfirm = "";
  registerAcceptTerms = "";
  emailInUse = false;
  loginFailed = false;

  nextStepTried = false;

  private _postalSub!: Subscription;
  private _loginSub!: Subscription;
  private _registerSub!: Subscription;

  user!: any;

  constructor(private postalService: PostalService,
    private loginService: LoginService,
    private registerService: RegisterService,
    private jobService: JobService) {
  }

  ngOnInit(): void {
    this.restoreLocalStorage();
    var sub = this.loginService.getActiveSession().subscribe({
      next: x => {
        if (x.firstName) {
          this.user = x;
          this.amountOfSteps = 3;
        }
        sub.unsubscribe();
      }
    });
  }

  nextStep(canContinue: boolean) {
    if (!canContinue) {
      this.nextStepTried = true;
    }
    else {
      console.log('scroll');
      window.scroll(0, 0);
      this.nextStepTried = false;
      window['dataLayer'] = window['dataLayer'] || [];
      window['dataLayer'].push({
        'event': 'Wizzard.Next.Click.Step' + this.step
      });

      this.step++;

      if (this.step == 3 && this.fileUploaded && !this.file1)
        alert('De eerder geuploade afbeelding is verlopen. Upload je afbeelding opnieuw');
    }
  }
  previousStep() {
    window['dataLayer'].push({
      'event': 'Wizzard.Previous.Click.Step' + this.step
    });
    this.nextStepTried = false;
    this.step--;
  }

  file1Change(event: Event) {
    this.fileUploaded = true;
    const target = event.target as HTMLInputElement;
    var file = (target.files as FileList)[0];
    if (file.size > 8388608) alert('Maximale bestandsgrootte is 8MB')
    else {
      this.file1 = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.file1Preview = event.target.result;
      };
      this.guideProvided = true;
    }
  }

  file2Change(event: Event) {
    const target = event.target as HTMLInputElement;
    var file = (target.files as FileList)[0];
    if (file.size > 8388608) alert('Maximale bestandsgrootte is 8MB')
    else {
      this.file2 = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.file2Preview = event.target.result;
      };
    }
  }

  checkAddress() {
    if (this.postal && this.houseNumber)
      this._postalSub = this.postalService.getPostalData(this.postal, this.houseNumber, this.houseNumberAddition).subscribe({
        next: x => {
          if (x && x.results) {
            var address = x.results[0];
            this.street = address.street;
            this.city = address.municipality;
            this.addressValid = true;
          }
          this._postalSub.unsubscribe();
        }
      });
  }

  checkMail() {
    if (this.registerEmail) {
      this._registerSub = this.registerService.emailExists(this.registerEmail.trim()).subscribe({
        next: x => {
          this.emailInUse = x;
          this._registerSub.unsubscribe();
        }
      });
    }
  }

  login() {

    if (this.loginUserName.trim() && this.loginPassword.trim()) {
      this._loginSub = this.loginService.tryLogin(this.loginUserName.trim(), this.loginPassword.trim()).subscribe({
        next: x => {
          if (!x) {
            this.loginFailed = true;
          }
          else {
            window['dataLayer'].push({
              'event': 'Wizzard.Login'
            });
            this.loginFailed = false;
            this._loginSub.unsubscribe();
            this.user = x;
            var sub: Subscription = this.loginService.doSessionLogin(this.loginUserName.trim(), this.loginPassword.trim()).subscribe({
              next: x => {
                sub.unsubscribe();
                this.createJob(true);
              },
              error: x => {
                sub.unsubscribe();
                this.createJob(true);
              }
            });

          }
        }
      });
    }
  }

  register() {
    var data = this.buildRegisterData();
    var sub = this.registerService.registerUser(data).subscribe({
      next: x => {
        window['dataLayer'].push({
          'event': 'Wizzard.Register'
        });
        this.loginUserName = this.registerEmail.trim();
        this.loginPassword = this.registerPassword.trim();
        sub.unsubscribe();
        this.login();
      }
    })
  }

  createJob(canContinue: boolean) {
    if (!canContinue) {
      this.nextStepTried = true;
    }
    else {
      this.nextStepTried = false;
      var data = this.buildJobData();
      console.log('create job ' + JSON.stringify(data));
      var sub = this.jobService.createJob(data).subscribe({
        next: x => {
          this.clearLocalStorage();
          window['dataLayer'].push({
            'event': 'Wizzard.CreateJob'
          });
          console.log('Created job');
          var text = 'Je opdracht is succesvol geplaatst';
          var url = '/opdracht/' + x + '/details';
          sub.unsubscribe();
          var target = '/bericht?m=' + text + '&u=' + encodeURIComponent(url);
          window.location.href = target;
        }
      });
    }
  }

  private buildRegisterData(): any {
    var data = {
      firstName: this.registerFirstName.trim(),
      lastName: this.registerLastName.trim(),
      email: this.registerEmail.trim(),
      phone: '',
      street: this.street.trim(),
      houseNumber: this.houseNumber.trim(),
      houseNumberAddition: this.houseNumberAddition.trim(),
      password1: this.registerPassword.trim(),
      postal: this.postal.trim(),
      city: this.city.trim(),
      password2: this.registerPasswordConfirm.trim(),
      company: '',
      kvk: '',
      btw: '',
      radioSubscriptionType: ''
    }
    return data;
  }

  private buildJobData(): any {
    var data = new FormData();
    data.append('file1', this.file1);
    data.append('file2', this.file2);

    data.append('title', this.title.trim());
    data.append('description', this.description.trim());
    data.append('detailsLength', this.detailsLength.toString().trim());
    data.append('detailsWidth', this.detailsWidth.toString().trim());
    data.append('detailsHeight', this.detailsHeight.toString().trim());
    data.append('doorType', this.radioDoorType);
    if (this.cbDrawers) data.append('cbDrawers', 'true');
    if (this.cbLights) data.append('cbLights', '');
    data.append('txtExtra', this.txtExtra.trim());
    data.append('dateExecution', this.dateExecution.toString().trim());
    data.append('street', this.street.trim());
    data.append('houseNumber', this.houseNumber.trim());
    data.append('postal', this.postal.trim());
    data.append('city', this.city.trim());
    data.append('houseNumberAddition', this.houseNumberAddition.trim());
    if (this.manualUrl) data.append('manualUrl', this.manualUrl.trim());
    data.append('weekRange', this.weekRange.trim());
    return data;
  }

  private restoreLocalStorage() {
    var sessionObjJson = localStorage.getItem('jobFormSession');
    if (sessionObjJson) {
      var sessionObj: any = JSON.parse(sessionObjJson);
      if (sessionObj.weekRange) this.weekRange = sessionObj.weekRange;
      if (sessionObj.title) this.title = sessionObj.title;
      if (sessionObj.description) this.description = sessionObj.description;
      if (sessionObj.postal) this.postal = sessionObj.postal;
      if (sessionObj.houseNumber) this.houseNumber = sessionObj.houseNumber;
      if (sessionObj.houseNumberAddition) this.houseNumberAddition = sessionObj.houseNumberAddition;
      if (sessionObj.street) this.street = sessionObj.street;
      if (sessionObj.city) this.city = sessionObj.city;
      if (sessionObj.detailsLength) this.detailsLength = sessionObj.detailsLength;
      if (sessionObj.detailsWidth) this.detailsWidth = sessionObj.detailsWidth;
      if (sessionObj.detailsHeight) this.detailsHeight = sessionObj.detailsHeight;
      if (sessionObj.radioDoorType) this.radioDoorType = sessionObj.radioDoorType;
      if (sessionObj.cbDrawers) this.cbDrawers = sessionObj.cbDrawers;
      if (sessionObj.cbLights) this.cbLights = sessionObj.cbLights;
      if (sessionObj.cbExtra) this.cbExtra = sessionObj.cbExtra;
      if (sessionObj.txtExtra) this.txtExtra = sessionObj.txtExtra;
      if (sessionObj.dateExecution) this.dateExecution = sessionObj.dateExecution;
      if (sessionObj.fileUploaded) this.fileUploaded = sessionObj.fileUploaded;
    }
  }

  private clearLocalStorage() {
    localStorage.removeItem('jobFormSession');
  }

  private saveLocalStorage() {
    var sessionObj: any = {};
    sessionObj.weekRange = this.weekRange;
    sessionObj.title = this.title;
    sessionObj.description = this.description;
    sessionObj.postal = this.postal;
    sessionObj.houseNumber = this.houseNumber;
    sessionObj.houseNumberAddition = this.houseNumberAddition;
    sessionObj.street = this.street;
    sessionObj.city = this.city;
    sessionObj.detailsLength = this.detailsLength;
    sessionObj.detailsWidth = this.detailsWidth;
    sessionObj.detailsHeight = this.detailsHeight;
    sessionObj.radioDoorType = this.radioDoorType
    sessionObj.cbDrawers = this.cbDrawers;
    sessionObj.cbLights = this.cbLights;
    sessionObj.cbExtra = this.cbExtra
    sessionObj.txtExtra = this.txtExtra;
    sessionObj.dateExecution = this.dateExecution;
    sessionObj.fileUploaded = this.fileUploaded;

    localStorage.setItem('jobFormSession', JSON.stringify(sessionObj));
  }
}
